import React from 'react';

const Splash = () => {
	return (
		<div className="lds-loading">
			<div className="lds-ripple">
				<div></div>
				<div></div>
			</div>
		</div>
	);
};

export default Splash;
